import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection6Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/najfrq5wke`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection6Video;
